import React from 'react'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table'
import { Download, Loader2 } from 'lucide-react'
import { useMutation } from 'react-query'
import toast from 'react-hot-toast'
import axios from 'src/axios/axios'
import { useAppSelector } from 'src/hooks/redux'
import { RootState } from 'src/store'
import useAuth from 'src/hooks/useAuth'
import { downloadFile } from 'src/functions/actions/documents'
import { useTranslation } from 'react-i18next'

type Props = {
    document?: DocumentObject
}

const Attachments = ({document}:Props) => {
    const {t} = useTranslation()
    const {auth} = useAuth()

    const { mutate:downloadDocument, isLoading } = useMutation({
        mutationFn: async (id:number) => {
            try {
                toast.loading(`${t('Bijlage downloaden')}...`, {id:'downloadDocument', position:'top-center'})
                const { data } = await axios.get(`/attachments/get?attachmentid=${id}`)
                if(data.errorcode!==0){ throw new Error(data.message) }
                downloadFile(data.object.file, data.object.filename)
                toast.success(`${t('Bijlage gedownload')}!`, {id:'downloadDocument', position:'top-center'})
            } catch (error) {
                console.log(error);
                toast.error(`${t('Bijlage downloaden mislukt')}`, {id:'downloadDocument', position:'top-center'})
            }
        }
    })

  return (
    <Table>
        <TableHeader>
            <TableRow>
                <TableHead className='w-16'></TableHead>
                <TableHead>{t('Datum')}</TableHead>
                <TableHead>{t('Bestandsnaam')}</TableHead>
                <TableHead>{t('Opmerking')}</TableHead>
            </TableRow>
        </TableHeader>
        <TableBody>
            {document?.attachments && document.attachments.map((attachment, index)=>(
                <TableRow key={index}>
                    <TableCell>
                        <button disabled={isLoading} onClick={()=>{downloadDocument(attachment.documentsattachmentsid)}} className='flex items-center justify-center w-8 h-8 rounded-full bg-slate-50 text-slate-600'>
                            {isLoading ? <Loader2 className='w-4 h-4 animate-spin'/> : <Download className='w-4 h-4'/>}
                        </button>
                    </TableCell>
                    <TableCell>{attachment?.datecreated}</TableCell>
                    <TableCell>{attachment?.filename}</TableCell>
                    <TableCell>{attachment?.remark}</TableCell>
                </TableRow>
            ))}
            
        </TableBody>
    </Table>
  )
}

export default Attachments